import React from 'react'
import { useTranslation } from 'react-i18next'
import { BillingHistoryTableRow } from './BillingHistoryTableRow'
import { NoSubscription } from '../NoSubscription'

export const BillingHistoryTable = ({ payments, getInvoice }) => {
    const { t } = useTranslation()
    return (
        <>
            {payments.content.length ? (
                <div className="table table-2">
                    <ul className="table-header">
                        <li className="col col-1">{t('_pages._billing_and_payments.date_or_invoice')}</li>
                        <li className="col col-2">{t('_pages._billing_and_payments.product_name')}</li>
                        <li className="col col-3">{t('_pages._billing_and_payments.payment_method')}</li>
                        <li className="col col-4">{t('_pages._billing_and_payments.status')}</li>
                        <li className="col col-5">{t('_pages._billing_and_payments.total')}</li>
                        <li className="col col-6"></li>
                    </ul>
                    <ul className="table-list">
                        {payments.content.map((item, i) => (
                            <BillingHistoryTableRow key={i} item={item} getInvoice={getInvoice} />
                        ))}
                    </ul>
                </div>
            ) : (
                <NoSubscription />
            )}
        </>
    )
}
